// ═══════════════════════════════════════════════════════════════
// AGENCIAS · LIVE FEST (view.js)
// La pantalla de la sección «LIVE FEST» de la consola de agencias: el
// rótulo «LIVE FEST 26», un «cargando» y la cuenta atrás hasta la fecha que
// pone el backoffice (sin fecha, «Muy pronto»). La pinta la consola
// (owner-console/index.js) y la vista previa del backoffice (lib/
// agencyLiveFest.js la importa tal cual, con agency-live-fest.css).
//
// Sin «TikTok LIVE» en el rótulo: solo «LIVE FEST 26» (Javier). La letra es
// TikTok Sans (Google Fonts); la cambia una sola regla de agency-live-fest.css
// (--alf-font).
//
// mount(root, { config, t, locale, now }) → { update(config), destroy() }
//   config  { enabled, startsAt } (livefest/model.js › sanitize)
//   t       (clave, texto de respaldo) → texto
//   locale  BCP-47 para la fecha (AgenciasShared.locale() en la app)
//   now     () → ms (reloj; en las pruebas, uno de mentira)
// La cuenta atrás cambia cada segundo SOLO el texto de sus cifras; al llegar
// a la fecha se para.
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

(function (root) {
  'use strict';

  const FONT_ID = 'alf-font';
  const FONT_URL = 'https://fonts.googleapis.com/css2?family=TikTok+Sans:wdth,wght@75..150,300..900&display=swap';

  function ensureFont(doc) {
    try {
      if (!doc || !doc.head || doc.getElementById(FONT_ID)) return;
      const link = doc.createElement('link');
      link.id = FONT_ID;
      link.rel = 'stylesheet';
      link.href = FONT_URL;
      doc.head.appendChild(link);
    } catch (_) { /* sin la letra sale la de respaldo */ }
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // La «V» del logo del evento no es la de la fuente: el palo de la izquierda
  // va recto y solo el de la derecha se inclina (imagen de Javier, 28-oct-2026).
  // Dibujada a la medida de TikTok Sans 750 expandida al 140 %: alto = altura de las
  // mayúsculas (0,71 em), palo de 0,27 y ancho de 1,15 veces el alto, como en
  // la imagen. Unidades: alto 100.
  const V_SVG = '<svg class="alf-v" viewBox="0 0 115 100" aria-hidden="true" focusable="false"><path d="M0 0H27V71.2L81.1 0H115L39 100H0Z"/></svg>';

  /**
   * «LIVE FEST 26» con la V del logo (HTML). Lo usan el rótulo de la pantalla
   * y el botón del menú lateral. Quien lo pinta pone el texto para lectores de
   * pantalla (aria-label): aquí todo va aria-hidden salvo las letras.
   */
  function wordmarkHtml() {
    return `<span class="alf-logo-w">LI${V_SVG}E</span><span class="alf-logo-w">FEST</span><span class="alf-logo-yr">26</span>`;
  }
  const pad = (n) => String(Math.max(0, n | 0)).padStart(2, '0');

  function whenText(at, locale) {
    try {
      return new Date(at).toLocaleString(locale || undefined, { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch (_) {
      return new Date(at).toISOString().slice(0, 16).replace('T', ' ');
    }
  }

  function mount(host, opts) {
    const o = opts || {};
    const Model = root.AgenciasLiveFestModel;
    const t = typeof o.t === 'function' ? o.t : (_k, f) => f;
    const now = typeof o.now === 'function' ? o.now : () => Date.now();
    const doc = host && host.ownerDocument;
    let config = Model.sanitize(o.config);
    let timer = null;
    let dead = false;

    ensureFont(doc);

    const units = [
      ['days', t('agencies_lf_days', 'Días')],
      ['hours', t('agencies_lf_hours', 'Horas')],
      ['minutes', t('agencies_lf_min', 'Min')],
      ['seconds', t('agencies_lf_sec', 'Seg')],
    ];

    host.innerHTML = `
      <section class="alf">
        <div class="alf-glow" aria-hidden="true"><i></i><i></i></div>
        <div class="alf-in">
          <h1 class="alf-logo" aria-label="LIVE FEST 26"><span class="alf-wm" aria-hidden="true">${wordmarkHtml()}</span></h1>
          <div class="alf-loader" role="progressbar" aria-label="${esc(t('agencies_lf_loading', 'Preparando…'))}"><i></i></div>
          <p class="alf-title">${esc(t('agencies_lf_title', 'Estamos preparando el LIVE FEST'))}</p>
          <p class="alf-sub">${esc(t('agencies_lf_sub', 'Muy pronto tendrás aquí todo lo que tu agencia necesita para el LIVE FEST de TikTok.'))}</p>
          <div class="alf-count" data-alf-count>
            <p class="alf-count-k">${esc(t('agencies_lf_starts_in', 'Empieza en'))}</p>
            <div class="alf-cd" role="timer" aria-live="off">
              ${units.map(([id, label]) => `<div class="alf-cd-cell"><b data-alf-u="${id}">00</b><span>${esc(label)}</span></div>`).join('<i class="alf-cd-sep" aria-hidden="true">:</i>')}
            </div>
            <p class="alf-when" data-alf-when></p>
          </div>
          <p class="alf-note" data-alf-note hidden></p>
        </div>
      </section>`;

    const $ = (sel) => host.querySelector(sel);
    const countEl = $('[data-alf-count]');
    const noteEl = $('[data-alf-note]');
    const whenEl = $('[data-alf-when]');
    const cells = {};
    units.forEach(([id]) => { cells[id] = $(`[data-alf-u="${id}"]`); });

    function stop() { if (timer) { clearTimeout(timer); timer = null; } }

    function paint() {
      if (dead) return;
      stop();
      const at = now();
      const cd = Model.countdown(config.startsAt, at);
      if (!cd) {
        countEl.hidden = true;
        noteEl.hidden = false;
        noteEl.textContent = t('agencies_lf_nodate', 'Muy pronto');
        return;
      }
      if (cd.done) {
        countEl.hidden = true;
        noteEl.hidden = false;
        noteEl.textContent = t('agencies_lf_soon', 'Ya casi está: abrimos en cualquier momento.');
        return;
      }
      countEl.hidden = false;
      noteEl.hidden = true;
      cells.days.textContent = cd.days > 99 ? String(cd.days) : pad(cd.days);
      cells.hours.textContent = pad(cd.hours);
      cells.minutes.textContent = pad(cd.minutes);
      cells.seconds.textContent = pad(cd.seconds);
      whenEl.textContent = whenText(config.startsAt, o.locale);
      // Al siguiente segundo entero que falte (no un intervalo fijo que se desfasa).
      // Con 4,3 s se ve «5» hasta que quedan 4 s justos: dentro de 300 ms.
      const wait = (config.startsAt - at) - cd.total + 1000;
      timer = setTimeout(paint, Math.min(1000, Math.max(50, wait)));
    }

    paint();

    return {
      update(next) { config = Model.sanitize(next); paint(); },
      destroy() { dead = true; stop(); host.innerHTML = ''; },
    };
  }

  root.AgenciasLiveFestView = { mount, ensureFont, wordmarkHtml, FONT_URL };
})(typeof globalThis !== 'undefined' ? globalThis : window);
